// this code is shared across (at least):
// 1. /global-gutenberg-theme/src/Views/Snippets/LangSelector.php
// 2. /global-gutenberg-theme/views/snippets/lang-selector.twig

export default function marketDropdownWPML(options = {}) {
    try {
        const marketSelector = document.querySelector('.market-selector');

        if (marketSelector) {
            const marketCurrent = marketSelector.querySelector('.market.current');
            const marketsList = marketSelector.querySelector('.markets-list');
            const marketLinks = marketsList.querySelectorAll('a.market');
            // debugger
            const setLinkTabIndexes = (value) => {
                marketLinks.forEach(link => link.setAttribute('tabindex', value));
            };

            const openMarketMenu = () => {
                marketsList.hidden = false;
                marketsList.classList.add('open');
                marketCurrent.setAttribute('aria-expanded', 'true');
                setLinkTabIndexes('0');
                marketLinks[0]?.focus();
            };

            const closeMarketMenu = () => {
                marketsList.hidden = true;
                marketsList.classList.remove('open');
                marketCurrent.setAttribute('aria-expanded', 'false');
                setLinkTabIndexes('-1');
            };

            const toggleMarketMenu = () => {
                const isOpen = marketsList.classList.contains('open');
                isOpen ? closeMarketMenu() : openMarketMenu();
            };

            marketCurrent.onclick = () => toggleMarketMenu();

            marketCurrent.addEventListener('keydown', (e) => {
                if (['Enter', ' '].includes(e.key)) {
                    e.preventDefault();
                    toggleMarketMenu();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    openMarketMenu();
                } else if (e.key === 'Escape') {
                    closeMarketMenu();
                    marketCurrent.focus();
                }
            });

            document.addEventListener('click', (event) => {
                if (!marketSelector.contains(event.target)) {
                    closeMarketMenu();
                }
            });

            marketsList.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    closeMarketMenu();
                    marketCurrent.focus();
                }
            });
        }
    } catch (error) {
        console.error(error);
    }
}
